import { processTopologyData } from '@api/processors/topology';

const processTestSeriesEntity = (feedBlock) => ({
  label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
  topologies: feedBlock.data.map((topology) => processTopologyData(topology)),
  extraBlockinfo: {
    ...(feedBlock.extraBlockInfo || {})
  }
});

export default processTestSeriesEntity;
